import base from "@/api/base.js";
export default {
    FileUploadURL: base.ZCT_API + "/file/upload",
    SignatureUploadURL: base.ZCT_API + "/signature/uploadSignature",
};
